import { Reducer } from 'redux';
import { ProcessStepCodesEnum } from 'app/features/Member/Settings/Mobile/types';
import { MobileState, MobileActions, MEMBER_SETTING_MOBILE__SET_ACCESSIBLE_STEP, MEMBER_SETTING_MOBILE__SAVE_SETUP_PAGE_DATA, MEMBER_SETTING_MOBILE__SEND_MOBILE_OTP_DONE, MEMBER_SETTING_MOBILE__UPDATE_CACHE, MEMBER_SETTING_MOBILE__RESET_CACHE } from './types';

const initialState: MobileState = {
  process: {
    accessibleSteps: [ProcessStepCodesEnum.Auth],
    setup: {
      otpAuth: {}
    }
  }
};

const mobileReducer: Reducer<MobileState, MobileActions> = (state = initialState, action): MobileState => {
  switch (action.type) {
    // 設置可訪問步驟
    case MEMBER_SETTING_MOBILE__SET_ACCESSIBLE_STEP: {
      const currentStep = action.payload.step;
      const accessibleSteps = state.process.accessibleSteps.filter((step) => step !== currentStep).concat(currentStep);
      return { ...state, process: { ...state.process, accessibleSteps } };
    }
    // 緩存「輸入新手機號碼」(Step-2-1) 資料
    case MEMBER_SETTING_MOBILE__SAVE_SETUP_PAGE_DATA: {
      return { ...state, process: { ...state.process, setup: { ...state.process.setup, data: action.payload.data } } };
    }
    // 發送手機 OTP 驗證碼 完成
    case MEMBER_SETTING_MOBILE__SEND_MOBILE_OTP_DONE: {
      return { ...state, process: { ...state.process, setup: { ...state.process.setup, otpAuth: { ...state.process.setup.otpAuth, mobile: action.payload.response } } } };
    }
    // 更新流程資料緩存
    case MEMBER_SETTING_MOBILE__UPDATE_CACHE: {
      return { ...action.payload.cache };
    }
    // 重置資料緩存
    case MEMBER_SETTING_MOBILE__RESET_CACHE: {
      return { ...initialState };
    }
    // Default
    default:
      return state;
  }
};

export default mobileReducer;
